/* 🤖 this file was generated by svg-to-ts */
export const matIconNewspaper: {
  name: 'newspaper';
  data: string;
} = {
  name: 'newspaper',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m22 3-1.67 1.67L18.67 3 17 4.67 15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3 7 4.67 5.33 3 3.67 4.67 2 3v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V3zM11 19H4v-6h7v6zm9 0h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4H4V8h16v3z"/></svg>`
};
